// Renders a video transcript (Markdown) the way the app does: marked for the
// parsing, DOMPurify to strip anything but plain formatting.

import { useMemo } from "react";
import DOMPurify from "dompurify";
import { marked } from "marked";

const ALLOWED_TAGS = [
  "h1", "h2", "h3", "h4", "h5", "h6",
  "p", "br", "strong", "em", "u", "s", "del",
  "a", "ul", "ol", "li", "blockquote",
  "code", "pre", "table", "thead", "tbody", "tr", "th", "td",
  "hr", "img",
];
const ALLOWED_ATTR = ["href", "target", "rel", "src", "alt", "title"];

function renderMarkdown(content: string): string {
  if (!content.trim()) return "";
  const raw = marked.parse(content, { breaks: true, gfm: true, async: false });
  return DOMPurify.sanitize(raw, { ALLOWED_TAGS, ALLOWED_ATTR });
}

export function MarkdownPreview({ content, compact }: { content: string; compact?: boolean }) {
  const html = useMemo(() => renderMarkdown(content), [content]);
  const cls = `co-prose${compact ? " compact" : ""}`;
  if (!html) {
    return (
      <div className={cls}>
        <p className="muted">Nothing to preview yet.</p>
      </div>
    );
  }
  return <div className={cls} dangerouslySetInnerHTML={{ __html: html }} />;
}
